import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";

export async function getRuleHistory(filters) {
    return await apiRequest({
        url: API_PATHS.getRuleHistory(filters),
        method: "GET",
    });
}
